// extracted by mini-css-extract-plugin
module.exports = {"LocationFlightCompany":"LocationFlightCompany_LocationFlightCompany__1fDmA","airlineName":"LocationFlightCompany_airlineName__2OHH-"};